import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found in callback URL');
        navigate('/login', { state: { error: 'Authentication failed. Please try again.' } });
        return;
      }

      // Process the session
      const result = await processGoogleCallback(sessionId);

      if (result.success) {
        // Navigate to dashboard with user data
        navigate('/dashboard', { state: { user: result.user } });
      } else {
        navigate('/login', { state: { error: result.error } });
      }
    };

    processCallback();
  }, [location, navigate, processGoogleCallback]);

  return (
    <div className="min-h-screen bg-stone-900 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-emerald-400 animate-spin mx-auto mb-4" />
        <p className="text-stone-400">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
